// Este archivo inicializa y configura vanilla-cookieconsent para Evanhub
import 'vanilla-cookieconsent/dist/cookieconsent.css';

export function runCookieConsentConfig(lang = 'es') {
    window.CookieConsent.run({
        guiOptions: {
            consentModal: {
                layout: "box",
                position: "bottom left",
                equalWeightButtons: true,
                flipButtons: false
            },
            preferencesModal: {
                layout: "box",
                position: "right",
                equalWeightButtons: true,
                flipButtons: false
            }
        },
        categories: {
            necessary: {
                readOnly: true
            },
            analytics: {}
        },
        language: {
            default: lang || "es",
            translations: {
                en: {
                    consentModal: {
                        title: "We value your privacy",
                        description: "We use cookies to improve your browsing experience, show you personalized ads or content, and analyze our traffic. By clicking 'Accept all,' you consent to our use of cookies.",
                        acceptAllBtn: "Accept all",
                        acceptNecessaryBtn: "Reject all",
                        showPreferencesBtn: "Manage preferences",
                        footer: "<a href=\"/en/privacy-policies\">Privacy Policy</a>\n<a href=\"/en/terms-and-conditions\">Terms and conditions</a>"
                    },
                    preferencesModal: {
                        title: "Consent Preferences Center",
                        acceptAllBtn: "Accept all",
                        acceptNecessaryBtn: "Reject all",
                        savePreferencesBtn: "Save preferences",
                        closeIconLabel: "Close modal",
                        serviceCounterLabel: "Service|Services",
                        sections: [
                            {
                                title: "Cookie Usage",
                                description: "We use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want."
                            },
                            {
                                title: "Strictly Necessary Cookies <span class=\"pm__badge\">Always Enabled</span>",
                                description: "These cookies are essential for the proper functioning of the website. Without them, the site would not work correctly.",
                                linkedCategory: "necessary"
                            },
                            {
                                title: "Analytics Cookies",
                                description: "These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site.",
                                linkedCategory: "analytics"
                            },
                            {
                                title: "More information",
                                description: "For any queries in relation to our policy on cookies and your choices, please <a class=\"cc__link\" href=\"mailto:info@evanhub.com\">contact us</a>."
                            }
                        ]
                    }
                },
                es: {
                    consentModal: {
                        title: "Valoramos tu privacidad",
                        description: "Usamos cookies para mejorar su experiencia de navegación, mostrarle anuncios o contenidos personalizados y analizar nuestro tráfico. Al hacer clic en “Aceptar todo” usted da su consentimiento a nuestro uso de las cookies.",
                        acceptAllBtn: "Aceptar todo",
                        acceptNecessaryBtn: "Rechazar todo",
                        showPreferencesBtn: "Gestionar preferencias",
                        footer: "<a href=\"/es/politicas-de-privacidad\">Política de privacidad</a>\n<a href=\"/es/terminos-y-condiciones\">Términos y condiciones</a>"
                    },
                    preferencesModal: {
                        title: "Preferencias de Consentimiento",
                        acceptAllBtn: "Aceptar todo",
                        acceptNecessaryBtn: "Rechazar todo",
                        savePreferencesBtn: "Guardar preferencias",
                        closeIconLabel: "Cerrar modal",
                        serviceCounterLabel: "Servicios",
                        sections: [
                            {
                                title: "Uso de Cookies",
                                description: "Utilizamos cookies para garantizar las funciones básicas del sitio web y mejorar tu experiencia en línea. Puedes optar por activar o desactivar cada categoría cuando lo desees."
                            },
                            {
                                title: "Cookies Estrictamente Necesarias <span class=\"pm__badge\">Siempre Habilitadas</span>",
                                description: "Estas cookies son indispensables para que el sitio web funcione correctamente, permitiendo tareas como el inicio de sesión o la seguridad.",
                                linkedCategory: "necessary"
                            },
                            {
                                title: "Cookies Analíticas",
                                description: "Estas cookies nos permiten contar las visitas y fuentes de tráfico para poder medir y mejorar el rendimiento de nuestra plataforma.",
                                linkedCategory: "analytics"
                            },
                            {
                                title: "Más información",
                                description: "Si tienes dudas sobre nuestra política de cookies, puedes escribirnos a <a class=\"cc__link\" href=\"mailto:info@evanhub.com\">nuestro correo de contacto</a>."
                            }
                        ]
                    }
                }
            },
            //autoDetect: "browser"
        }
    });
    window._ccRun = true;
    console.log('[cookieConsent] CookieConsent inicializado');
}
